import { useQuery as i, skipToken as t, keepPreviousData as u } from "@tanstack/vue-query";
import { computed as l, toValue as s } from "vue";
import { pricingRuleKeys as a } from "./pricing-rule-keys.js";
const c = 5, p = 60, E = 1e3, I = c * p * E, R = (n, r, o) => i(
  l(() => {
    const e = s(r);
    return {
      staleTime: I,
      placeholderData: u,
      ...o,
      queryKey: a.bidRange(e?.ruleId ?? null, e?.bid ?? null),
      queryFn: e === null ? t : async () => n.pricingRule.bidRange(e)
    };
  })
);
export {
  R as usePricingRuleBidRange
};
//# sourceMappingURL=pricing-rule-queries.js.map
